import Form from '@components/data-driven-form/Form';
import { useQuery } from '@tanstack/react-query';
import { JpaQueries, JPA_QUERY_KEYS } from '@src/api/services/jpa';
import Loader from '@components/loader/Loader';
import { useJpa, useRequest } from '@stores';
import { QUESTION_TYPE } from '@components/data-driven-form/ddf.validation';

export const generateJpaFormName = (jpaBasicInfo) => `${jpaBasicInfo.orgName} - ${jpaBasicInfo.formCode}`;

const JpaForm = ({ formId, group, requestId, stepNo, version, componentId }) => {
  const { setAnswer, setTableInputAnswer, setContactAnswer } = useJpa();
  const { isFormReadOnly: isReadOnly, updateSection, isSectionValid, getSections } = useRequest();

  const { data, isLoading } = useQuery({
    queryKey: [JPA_QUERY_KEYS.GET_FORM, formId],
    queryFn: () =>
      JpaQueries.getForm({
        formId,
        requestId,
        version: version || 0,
      }),
    enabled: Number.isInteger(formId),
  });

  const handleOnChange = (val, questionId, questionTypeId, formId) => {
    if (questionTypeId === QUESTION_TYPE.table) {
      setTableInputAnswer(val, questionId, formId);
    } else if (questionTypeId === QUESTION_TYPE.contact || questionTypeId === QUESTION_TYPE.basicContact) {
      setContactAnswer(val, questionId, questionTypeId, formId);
    } else {
      setAnswer(val, questionId, questionTypeId, formId);
    }
    //Do not make section dirty when adding a row to a table
    if (!(questionTypeId === QUESTION_TYPE.table && val?.action === 'add')) {
      updateSection(stepNo, { dirty: true });
    }
  };

  const handleOnValidationChange = (isValid) => {
    if (isSectionValid(stepNo) === isValid) {
      return;
    } else {
      updateSection(stepNo, { valid: isReadOnly ? true : isValid });
      if (group) {
        const parentIndex = group?.parentIndex;

        if (!parentIndex) {
          return;
        }
        const currentSections = getSections();
        const isGroupValid = group?.indexes.every((index) => currentSections[index]?.valid);

        updateSection(parentIndex, { valid: isReadOnly ? true : isGroupValid });
      }
    }
  };

  if (isLoading) {
    return <Loader variant='page' />;
  }

  return (
    <Form
      componentId={componentId}
      formData={data?.jpaForm}
      isInformation={false}
      isReadOnly={isReadOnly}
      onChange={handleOnChange}
      onValidationChange={handleOnValidationChange}
      stepNo={stepNo}
    />
  );
};
export default JpaForm;
